module.exports = __webpack_public_path__ + "img/zhangyn.f73e87c6.jpg";